import { Component, forwardRef, OnInit } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PositionClient, PositionDto } from '../../api-connector/sso-connector';
import { BaseAutocompleteControl } from '../base-autocomplete-control';
import { AutocompleteCacheService } from '../../services/autocomplete-cache.service';

@Component({
  selector: 'app-position-control',
  templateUrl: './position-control.component.html',
  styleUrls: ['./position-control.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PositionControlComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => PositionControlComponent),
      multi: true,
    }
  ]
})
export class PositionControlComponent extends BaseAutocompleteControl<PositionDto> implements OnInit {

  constructor(
    private positionClient: PositionClient,
    private cache: AutocompleteCacheService
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  protected fetchItems(searchValue: string): Observable<PositionDto[]> {
    const cacheKey = `position_search_${searchValue}`;
    return this.cache.wrap(cacheKey, this.positionClient.getPositionByKeySearch(searchValue).pipe(
      map(items => items || [])
    ));
  }

  getDisplayValue(item: PositionDto | null): string {
    return item?.name || '';
  }

  protected isValidItem(value: any): boolean {
    return value instanceof PositionDto;
  }
}
